var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 17 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#261F56",
    d: "M14.69 3.742a6.544 6.544 0 0 0 1.643-1.703 6.837 6.837 0 0 1-1.89.517A3.262 3.262 0 0 0 15.886.743a6.555 6.555 0 0 1-2.08.794 3.28 3.28 0 0 0-5.674 2.244c0 .26.022.51.076.748a9.284 9.284 0 0 1-6.76-3.431 3.285 3.285 0 0 0 1.008 4.384 3.24 3.24 0 0 1-1.483-.404v.036a3.295 3.295 0 0 0 2.628 3.223 3.274 3.274 0 0 1-.86.108 2.9 2.9 0 0 1-.62-.056 3.311 3.311 0 0 0 3.064 2.285 6.59 6.59 0 0 1-4.067 1.399c-.269 0-.527-.012-.785-.045A9.234 9.234 0 0 0 5.365 13.5c5.788 0 9.561-4.829 9.324-9.758Z"
  })));
};
export default SvgTwitter;